import { type ReactNode } from 'react';
const DEFAULT_IMAGE = <img className={'aspect-[3/2] h-[128px] w-[192px] shrink-0'} src="/assets/empty_avatar.webp" alt={'mark'} />;
interface EmptyListStateProps {
  /** 기본 일러스트 대신 쓸 이미지. */
  image?: ReactNode;
  /** 검색 중이면 그 검색어. 제목 위에 따옴표로 감싸 보여 준다. */
  keyword?: string;
  title: string;
  description: string;
  /** 제목·설명 아래의 행동(버튼·링크). 없으면 그리지 않는다. */
  action?: ReactNode;
}

/**
 * 목록이 비었을 때의 표시 골격 — 그림 · 검색어 · 제목 · 설명 · 행동.
 *
 * 무엇의 목록인지 모른다. 문구·행동·트래킹은 쓰는 쪽이 정해서 넘긴다
 * (퀴즈는 `EmptyQuizList`, 폴더는 `EmptyFolderList`).
 */
export const EmptyListState = ({
  image = DEFAULT_IMAGE,
  keyword,
  title,
  description,
  action
}: EmptyListStateProps) => {
  return <div className={'flex flex-1 flex-col items-start justify-center py-2xl'} data-sentry-component="EmptyListState" data-sentry-source-file="EmptyListState.tsx">
      <div className={'flex w-full flex-col items-center justify-center gap-md'}>
        <div className={'flex flex-col items-center justify-center gap-xs'}>
          {image}
          {keyword && <span className={'text-heading-md-bold text-default'}>
              {'"' + keyword + '"'}
            </span>}
          <span className={'text-heading-md-bold text-alternative'}>
            {title}
          </span>
          <span className={'text-body-lg-medium text-assistive'}>
            {description}
          </span>
        </div>
        {action}
      </div>
    </div>;
};